import { getLocale } from "../runtime";

const sv_categoryimagealt = /** @type {(inputs: {category: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Kategoribild för ${inputs.category}`
};

const categoryimagealt = /** @type {(inputs: {category: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_categoryimagealt(inputs)
	return "categoryImageAlt";
};

export { categoryimagealt as "categoryImageAlt" };